import { render, staticRenderFns } from "./BasicSelectionDialog.vue?vue&type=template&id=37a83b8d&"
import script from "./BasicSelectionDialog.vue?vue&type=script&lang=js&"
export * from "./BasicSelectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports